/* eslint-disable  */
import { saveAs } from "file-saver";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import { dataActionCreators } from "../../services/Actions";
import RenderAdminPage from "../RenderAdminPage";
import "./LoanBookings.css";
import PromptModal from "../Components/PromptModal";
import Loader from "../../Components/Loader";
import { Loader2 } from "lucide-react";

function AdminLoanApplicationDetailed() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  console.log("location", location);
  const loanDetailed = location?.state?.loan;
  const defaultImage = "/images/dev/success.png";
  const {
    MarkedAsPaidAppliedLoans,
    ResetDataResponse,
    MarkedAsRejectedAppliedLoansByAdmin
  } = bindActionCreators(dataActionCreators, dispatch);
  const data = useSelector((state) => state?.data);
  const response = data?.response;
  console.log("loanDetailed", loanDetailed);

  const [openPromptRejectModal, setPromptOpenRejectModal] = useState(false);
  const [error, setError] = useState("");
  const [rejectMessage, setRejectedMessage] = useState("");
  // Tracks the in-flight action so we show a spinner on that button instead of
  // the full-page loader.
  const [actionLoading, setActionLoading] = useState(null);

  // Clear the per-button spinner once the request finishes (success or error).
  useEffect(() => {
    if (!data.isLoading) setActionLoading(null);
  }, [data.isLoading]);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetDataResponse();
        history.goBack();
        // history.push("/admin/loans-paid");
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetDataResponse();
        // history.push('')
      }, 1500);
    }
  }, [response?.state]);
  
  return (
    <div>
      <RenderAdminPage title="Loan Details">
        {data.isLoading && !actionLoading && <Loader/>}
        <button
          onClick={() => history.goBack()}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-slate-100 dark:bg-gray-700 text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-gray-600 text-sm font-semibold transition-colors mb-4"
        >
          &larr; Back
        </button>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 p-6 mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <img
                className="w-16 h-16 rounded-full object-cover border-2 border-slate-200 dark:border-gray-600"
                src={loanDetailed?.user?.profile_image || "/images/dev/del.png"}
                alt="profile"
              />
              <div>
                <h3 className="text-lg font-bold text-slate-800 dark:text-slate-100">{loanDetailed?.user?.name}</h3>
                <p className="text-sm text-slate-500 dark:text-slate-400">{loanDetailed?.staff_id || loanDetailed?.user?.staff_id}</p>
              </div>
            </div>
            <div>
              {loanDetailed?.status === "paid" ? null : (
                <button
                  disabled={actionLoading === "paid"}
                  className="px-4 py-2 rounded-xl bg-green-600 hover:bg-green-700 text-white text-sm font-semibold transition-colors flex items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                  onClick={() => {
                    const body = { status: true };
                    setActionLoading("paid");
                    MarkedAsPaidAppliedLoans(loanDetailed?._id, body);
                  }}
                >
                  {actionLoading === "paid" && (
                    <Loader2 size={16} className="animate-spin" />
                  )}
                  Mark as paid
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 p-6">
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Full Name</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.user?.name}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Staff ID</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.user?.staff_id}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Facility</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.user?.facility}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Email Address</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.email}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Phone Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.personal_phone}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Date Of Birth</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.dateOfBirth}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Age</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.age}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Residential Address</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">
                {loanDetailed?.residential_address1} {loanDetailed?.residential_address2}
              </span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Work Address</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">
                {loanDetailed?.work_address1} {loanDetailed?.work_address2}
              </span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Work Phone</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.work_phone}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">ID Card Type</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.IdCardType}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">ID Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.IDCardNumber}</span>
            </div>

            <div className="border-t border-slate-200 dark:border-gray-600 my-4"></div>
            <h3 className="text-base font-bold text-slate-800 dark:text-slate-100 mt-4 mb-2 pt-4 border-t border-slate-200 dark:border-gray-600">Guarantor 1</h3>

            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Full name</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_name}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Guarantor Phone</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_phone}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Guarantor Staff ID</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_staff_id}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Ghana Card Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_ghana_card}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Ghana GPS Address</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_gps}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Occupation</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_occupation}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Mandate Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_mandate_number}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">OTP Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_otp_number}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Relationship</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_relationship}</span>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 p-6">
            <h3 className="text-base font-bold text-slate-800 dark:text-slate-100 mb-2">Guarantor 2</h3>

            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Full name</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_name2}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Guarantor Phone</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_phone2}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Guarantor Staff ID</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_staff_id2}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Ghana Card Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_ghana_card2}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Ghana GPS Address</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_gps2}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Occupation</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_occupation2}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Mandate Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_mandate_number2}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">OTP Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_otp_number2}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Relationship</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.guarantor_relationship2}</span>
            </div>

            <div className="border-t border-slate-200 dark:border-gray-600 my-4"></div>

            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Loan Amount</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.loanAmount}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Loan Term</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.loanTerm}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Affordability</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.affordability}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Mandate Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.mandateNumber}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">OTP Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.otpNumber}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Monthly Deduction</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.monthlyDeduction}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Loan Purpose</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.purposeForLoan}</span>
            </div>

            <div className="border-t border-slate-200 dark:border-gray-600 my-4"></div>

            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">SNNIT Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.ssnit}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Bank Name</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.bank_name}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Account Holder Name</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.bank_account_holder_name}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Bank Branch</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.bank_branch}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Account Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.bank_account_number}</span>
            </div>

            <div className="border-t border-slate-200 dark:border-gray-600 my-4"></div>

            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Employer Name</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.employer_name}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Employee Start Date</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{loanDetailed?.employment_start_date}</span>
            </div>

            <div className="grid grid-cols-2 gap-4 mt-4">
              <img className="rounded-xl border border-slate-200 dark:border-gray-700 object-cover" src={loanDetailed?.frontIDImage} alt="id_front" />
              <img className="rounded-xl border border-slate-200 dark:border-gray-700 object-cover" src={loanDetailed?.passportImage} alt="id_back" />
            </div>
          </div>
        </div>

        {openPromptRejectModal && (
          <PromptModal
            closeModal={setPromptOpenRejectModal}
            width={"auto"}
            title="Reject loan to officers"
          >
            <div className="relative  ">
              <div className="p-6 text-center">
                {error && (
                  <div className=" mb-2">
                    <a className="text-red-400 border px-2 py-1 rounded-full">
                      {error}
                    </a>
                  </div>
                )}
                <div className="mb-4">
                  <label
                    htmlFor="message"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Rejected message
                  </label>
                  <textarea
                    id="message"
                    rows="4"
                    onChange={(e) => setRejectedMessage(e.target.value)}
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Write the reason for rejecting loan here. The loan officers will see this..."
                  ></textarea>
                </div>

                <button
                  data-modal-toggle="popup-modal"
                  type="button"
                  onClick={() => {
                    if (rejectMessage === "") {
                      setError("Please add message first");

                      setTimeout(() => {
                        setError("");
                      }, 5000);
                    } else {
                      //mark as rejected
                      const payload = {
                        status: true,
                        message: rejectMessage,
                        officerRejected: true,
                        rejectedBy: 'ADMIN'
                      };

                      MarkedAsRejectedAppliedLoansByAdmin(loanDetailed?._id,
                        payload);
                      setRejectedMessage("");

                      setPromptOpenRejectModal(false);
                    }
                  }}
                  className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                >
                  Reject
                </button>
                <button
                  data-modal-toggle="popup-modal"
                  type="button"
                  className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  onClick={() => setPromptOpenRejectModal(false)}
                >
                  No, cancel
                </button>
              </div>
            </div>
          </PromptModal>
        )}

        <ToastContainer autoClose={3000} />
      </RenderAdminPage>
    </div>
  );
}

export default AdminLoanApplicationDetailed;
